export default "__VITE_ASSET__D$6SpQ7I__"